import { Component, inject } from '@angular/core';
import { FizickiObjekt } from '@app/shared/models/fizicki-objekt';
import {
  ActionComponent,
  ItemInfo,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { catchError, finalize, first, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-odabir-fizickog-za-predaju',
  templateUrl: './odabir-fizickog-za-predaju.component.html'
})
export class OdabirFizickogZaPredajuComponent extends ActionComponent {
  public showDialog = false;

  private itemViewProvider = inject(ItemViewProviderDirective);
  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  public onSelectedItem(jedinice: FizickiObjekt[]) {
    this.itemViewProvider.item$
      .pipe(
        first(),
        switchMap((parent) => {
          return this.listviewProvider
            .executeAction('potvrdiDodavanjeFizickogZaPredaju', {
              $selected: jedinice,
              $parentId: new ItemInfo(parent).id
            })
            .pipe(
              tap(() => {
                const message =
                  jedinice.length > 1
                    ? 'Fizički objekti uspješno dodani'
                    : 'Fizički objekt uspješno dodan';
                this.notificationService.success(message);
                this.listviewProvider.refresh();
              }),
              catchError((e) => {
                const errorMessage =
                  jedinice.length > 1
                    ? 'Greška pri dodavanju fizičkih objekata'
                    : 'Greška pri dodavanju fizičkog objekta';
                this.notificationService.error(errorMessage);
                throw e;
              }),
              finalize(() => {
                this.showDialog = false;
              })
            );
        })
      )
      .subscribe();
  }

  override execute(): void {
    this.showDialog = true;
  }
}
